export const BMILevel = [
  {
    lt: 18.5,
    label: "Underweight",
    gainRange: [13, 18],
  },
  {
    lt: 25,
    label: "Healthy",
    gainRange: [11, 16],
  },
  {
    lt: 30,
    label: "Overweight",
    gainRange: [7, 11],
  },
  {
    lt: 40,
    label: "Obese",
    gainRange: [5, 9],
  },
  {
    lt: Number.MAX_VALUE,
    label: "Extremely Obese",
    gainRange: [5, 9],
  },
] as {
  lt: number
  label: string
  gainRange: [number, number]
}[]
